import HeroSection from "./components/HeroSection";
import FeaturedProductSection from "./components/FeaturedProductSection";
import TrustSection from "./components/TrustSection";
import ReviewsSection from "./components/ReviewsSection";
import LookbookSection from "./components/LookbookSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <div>
      <HeroSection />
      <FeaturedProductSection />
      <TrustSection />
      <ReviewsSection />
      <LookbookSection />
      <CTASection />
    </div>
  );
}